export function logError(maybeError, info) {
  console.error(maybeError)
}
